"use client";
import React, { useState } from "react";
import HeaderNavigation from "./HeaderNavigation.component";
import { CITIES_DATA } from "@/constants/cities";
import { useDispatch, useSelector } from "react-redux";
import { setCity } from "@/redux/slices/locationSlice";

const HeaderNavigationContainer = () => {
  const [cities, setCities] = useState(CITIES_DATA);
  const { city } = useSelector((state) => state.location);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const dispatch = useDispatch();
  const handleCityChange = (selectedOption) => {
    dispatch(setCity({selectedCity:selectedOption?.value}));
  };
  
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  const containerProps = {
    cities,
    isMenuOpen,
    city
  };
  const containerMethods = {
    toggleMenu,
    handleCityChange
  };
  return (
    <HeaderNavigation
      containerProps={containerProps}
      containerMethods={containerMethods}
    />
  );
};

export default HeaderNavigationContainer;
